import gql from 'graphql-tag';

export default gql`
query listFA_CustomerSpecialPricesTypes($languageId: Int){
    fakturaAssist{
    listFA_CustomerSpecialPricesTypes(languageId: $languageId){
		id
		name
    }
    
  }
}`;
